import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _PhysicalTakingItemCatalog, _TakingInventory } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectFixedAsset } from "../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAsset/SelectFixedAsset";
import { AccountEditor } from "../../../../editor/AccountEditor";
import usePaginator from "../../../../theme/Component/usePaginator";
import { PhysicalTakingConstantsSelect } from "../PhysicalTakingConstantsSelect";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { SelectProductEditor } from "../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
interface Props {
    idPhysicalTaking: number;
}


export const TakingInventoryCatalog = ({ idPhysicalTaking }: Props) => {

    const TakingInventory = useDataBean(_TakingInventory);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [FixedAsset, setFixedAsset] = useState<any>(null)
    const [FixedAssetitem, setFixedAssetitem] = useState<any>(null)
    const [Account, setAccount] = useState<any>(null)
    const [Product, setProduct] = useState<any>(null)
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const [State, setState] = useState<any>(null)
    const [ticketCode, setticketCode] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idPhysicalTaking, paginador.page])

    const getLista = () => {

        TakingInventory.instance.getPhysicalTakingInventoryCatalog(idPhysicalTaking, FixedAsset, regexStr, State, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {

                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)

                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        TakingInventory.setBean({
            IDPhysicalTaking: idPhysicalTaking
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        TakingInventory.deleteItemVoid(TakingInventory.bean.IDItem).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        TakingInventory.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPhysicalTakingItem', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Código de Producto', property: 'ProductCode', visible: true },
        { title: 'Cantidad Inicial', property: 'InitialQuantity', visible: true },
        { title: 'Cantidad Registrada', property: 'Quantity', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${TakingInventory.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <BasicPage titulo="Consultar Registro de Toma Física de Inventario">
            <div className="row">
                <div className="col-md-4">
                    <SelectProductEditor value={Product} onChange={(e) => { setProduct(e.IDProduct) }} label="Producto" />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4">
                    <PhysicalTakingConstantsSelect idSelector={State} onChange={(e) => { setState(e) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton value="BUSCAR" icon="ri-file-add-line" eventClick={getLista} ></BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={TakingInventory.setBean} next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                        customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <></>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {TakingInventory.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}